import gql from 'graphql-tag'

export const ChatIamTypingMessageMutation = gql`
  mutation IamTypingMessage ($projectId: Uint!, $chatIndex: Uint!) {
    chatIamTypingMessage (projectId: $projectId, chatIndex: $chatIndex) {
        succeed
    }
  }
`

export const ChatInterceptAiControlMutation = gql`
  mutation ChatInterceptAIControl($projectId: Uint!, $chatIndex: Uint!) {
    status: chatInterceptAiControl (projectId: $projectId, chatIndex: $chatIndex) {
      succeed
    }
  }
`

export const ChatSendMessageMutation = gql`
  mutation ChatSendMessage($input: ChatSendMessageInput!) {
    status: chatSendMessage (input: $input) {
      succeed
    }
  }
`
